'use strict';

var style = require('./style');

module.exports = style({
  prop: 'maxWidth',
  cssProperty: 'maxWidth',
  key: 'maxWidths',
  numberToPx: true
});


//////////////////
// WEBPACK FOOTER
// ./~/@hackclub/design-system/~/styled-system/dist/max-width.js
// module id = 77
// module chunks = 35783957827783 95570949031736 114276838955818 162898551421021